import { computed, inject } from "vue";
import type {
  ICProdProvider,
  ICProdProviderMethods
} from "@/models/providers/contractProduct";

/**
 * Composable to inject contract product provider data and methods.
 */
export function useCProdInjector() {
  const cProdDataProvider = inject<() => ICProdProvider>(
    "contractProductProvider"
  );
  const cProdMethodsProvider = inject<ICProdProviderMethods>(
    "contractProductProviderMethods"
  );

  if (!cProdDataProvider || !cProdMethodsProvider) {
    throw new Error("'contractProductProvider' was not provided");
  }

  const cProdData = computed(() => cProdDataProvider());

  return {
    cProdData,
    cProdMethods: cProdMethodsProvider
  };
}
